import './App.css';
import Router from './routes';
import "./components/bankvole.css"

function App() {
  return (
    <div>
   <Router/>
    </div>
  );
}

export default App;
